import styled from 'styled-components';

export default styled.div`
    .back {
        margin-top: 24px;
        margin-left: 24px;
        p {
            text-align: center;
        }
        h1,
        h2 {
            text-align: center;
        }
    }
    .code p {
        text-align: center;
        @media (min-width: 800px) {
            font-size: 10rem;
        }
        @media (max-width: 800px) {
            font-size: 3rem;
        }
    }
`;
